import React, { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import LabourPanel from '../components/LabourPanel';
import { apiGet } from '../lib/api';

export default function Labour() {
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState('');

  useEffect(() => {
    apiGet('/projects').then(p => {
      setProjects(p);
      if (p.length && !active) setActive(p[0].id);
    }).catch(() => {});
  /* eslint-disable-next-line */
  }, []);

  return (
    <div>
      <PageHeader
        overline="Site Operations"
        title="Labour Attendance"
        subtitle="Subcontractor-wise attendance with named worker register"
      />
      <div className="bg-white border border-slate-200 rounded-sm p-4 mb-4">
        <label className="text-[10px] font-display font-bold uppercase tracking-widest text-slate-500 block mb-1.5">Project</label>
        <select value={active} onChange={e => setActive(e.target.value)} data-testid="labour-project-select"
          className="px-3 py-2 border border-slate-300 rounded-sm text-sm bg-white w-full md:w-96">
          <option value="">— Select project —</option>
          {projects.map(p => <option key={p.id} value={p.id}>{`${p.code} · ${p.name}`}</option>)}
        </select>
      </div>
      {active ? (
        <div className="bg-white border border-slate-200 rounded-sm p-5">
          <LabourPanel projectId={active} />
        </div>
      ) : (
        <div className="text-center py-16 border border-dashed border-slate-200 rounded-sm text-xs uppercase tracking-widest font-display text-slate-400">
          Select a project to view attendance
        </div>
      )}
    </div>
  );
}
